import React from "react";
import PropTypes from "prop-types";

const ItemMenuSolution = ({ link, handleClick, handleOnMouseOver, handleOnMouseOut }) => {
  const { url, title, extraClass, image, body } = link;
  const ariaLabel = { "aria-label": title };
  const additionalClass = extraClass || "";
  const linkClass = `sub-link sub-link--solution d-block ${additionalClass}`;
  return (
    <a
      href={url}
      className={linkClass}
      {...ariaLabel}
      onClick={() => handleClick(title, url)}
      onMouseOver={() => handleOnMouseOver(title, image, body)}
      onMouseOut={handleOnMouseOut}
    >
      {title}
    </a>
  );
};

ItemMenuSolution.defaultProps = {
  handleClick: () => {},
  handleOnMouseOver: () => {},
  handleOnMouseOut: () => {},
};

ItemMenuSolution.propTypes = {
  link: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
};

export default ItemMenuSolution;
